// src/app/modules/AccessControl/pages/access-logs-table/column-formatters/TimeColumnFormatter.jsx
import React from "react";
import Moment from 'moment';
import { Clock } from 'lucide-react';

export function TimeColumnFormatter(cellContent, row) {
  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5 }}>
        {Moment(row.entry_time).format("MMM DD, YYYY")}
      </div>
      <div className="sety-tbl-sub" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Clock size={12} />
        {Moment(row.entry_time).format("HH:mm A")}
      </div>
      {row.exit_time && (
        <div className="sety-tbl-sub" style={{ color: 'var(--green)' }}>
          Left: {Moment(row.exit_time).format("HH:mm A")}
        </div>
      )}
      {row.duration_minutes && (
        <div className="sety-tbl-sub">Duration: {row.duration_minutes} min</div>
      )}
    </div>
  );
}
